// extracted by mini-css-extract-plugin
export var searchHeader = "_37-0";
export var searchHeaderDark = "_37-1";